import { useField, useFormikContext } from "formik";
import { motion } from "framer-motion";
import { FC } from "react";

import type { DateFields } from "web/Pages/Tourism/DomesticTourismForm/domesticTourismFormFields";

import DatepickerFormikMUI from "web/Layout/Datepicker/DatepickerCafe/datepickerFormik";

import { dayMilliseconds } from "web/constants/date";

import { names } from "../domesticTourismFormFields";
import classes from "./dateFields.scss";

const variants = {
  open: {
    opacity: 1,
    height: "auto",
  },
  closed: {
    opacity: 0,
    height: 0,
  },
};
const transition = { duration: 0.2 };

interface IProductDateFieldsMobileProps {
  fields: DateFields;
  showErrorContainers?: boolean;
}

const ProductDateFieldsMobile: FC<IProductDateFieldsMobileProps> = ({
  fields,
  showErrorContainers = true,
}) => {
  const { values } = useFormikContext<Record<string, string>>();

  const minDate =
    values[names.dateFrom] && +values[names.dateFrom]
      ? +values[names.dateFrom] + dayMilliseconds
      : Date.now() + dayMilliseconds;
  const maxDate =
    values[names.dateTo] && +values[names.dateTo]
      ? +values[names.dateTo] - dayMilliseconds
      : null;

  return (
    <div className={classes.root}>
      {fields.map(({ name, label, placeholder }, index) => {
        const [, meta] = useField({ name });
        const isError = meta.error && meta.touched;
        const errorClassName = isError ? classes.errorShown : classes.error;
        const [minDateValue, maxDateValue] =
          name === names.dateFrom ? ["today", maxDate] : [minDate, null];

        const id = `date-field-${name}-${index}`;

        return (
          <div className={classes.wrapper} key={name}>
            <label className={classes.badge} htmlFor={id}>
              {label}
            </label>
            <div>
              <DatepickerFormikMUI
                id={id}
                name={name}
                placeholder={placeholder}
                minDate={minDateValue}
                maxDate={maxDateValue}
              />
              {showErrorContainers && (
                <motion.div
                  className={errorClassName}
                  initial="closed"
                  variants={variants}
                  animate={isError ? "open" : "closed"}
                  transition={transition}
                >
                  {meta.error}
                </motion.div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ProductDateFieldsMobile;
